(function () {
  function initThumbnailVariantSync() {
    const handle = window.ShopifyAnalytics &&
                   window.ShopifyAnalytics.meta &&
                   window.ShopifyAnalytics.meta.product &&
                   window.ShopifyAnalytics.meta.product.handle;
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {

        const featuredMap = {};
        product.variants.forEach(function (v) {
          if (v.featured_media && !featuredMap[v.option1]) {
            featuredMap[v.option1] = String(v.featured_media.id);
          }
        });

        const featuredPositions = {};
        product.media.forEach(function (m, i) {
          const mid = String(m.id);
          const color = Object.keys(featuredMap).find(function (c) {
            return featuredMap[c] === mid;
          });
          if (color) featuredPositions[i] = color;
        });

        const sortedPos = Object.keys(featuredPositions)
          .map(Number).sort(function (a, b) { return a - b; });

        const mediaColorMap = {};
        product.media.forEach(function (m, idx) {
          const mid = String(m.id);
          const direct = Object.keys(featuredMap).find(function (c) {
            return featuredMap[c] === mid;
          });
          if (direct) { mediaColorMap[mid] = direct; return; }
          const before = sortedPos.filter(function (p) { return p <= idx; });
          const after  = sortedPos.filter(function (p) { return p > idx; });
          if (before.length) {
            mediaColorMap[mid] = featuredPositions[before[before.length - 1]];
          } else if (after.length) {
            mediaColorMap[mid] = featuredPositions[after[0]];
          }
        });

        console.log('Media map ready:', Object.keys(mediaColorMap).length, 'items');

        function getColorSelect() {
          return document.querySelector('select[id^="Option-"][id$="-0"]');
        }

        var debounceTimer = null;
        var isChanging = false;

        function handleActiveSlide(slideEl) {
          if (isChanging) return;
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            const parts = slideEl.id.split('__main-');
            if (!parts[1]) return;
            const mediaId = parts[1];
            const color = mediaColorMap[mediaId];
            if (!color) return;
            const colorSelect = getColorSelect();
            if (!colorSelect) return;
            if (colorSelect.value === color) return;
            isChanging = true;
            colorSelect.value = color;
            colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
            setTimeout(function () { isChanging = false; }, 800);
            console.log('Color changed to:', color);
          }, 150);
        }

        function attachObserver() {
          const mediaList = document.querySelector('.product__media-list');
          if (!mediaList) return;

          const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              const target = mutation.target;
              if (target.tagName !== 'LI') return;
              if (!target.classList.contains('is-active')) return;
              handleActiveSlide(target);
            });
          });

          observer.observe(mediaList, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true
          });

          console.log('Observer attached ✅');
        }

        attachObserver();
        console.log('Sync ready ✅');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbnailVariantSync);
  } else {
    initThumbnailVariantSync();
  }
})();